import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Popover, Input, message, Spin, Avatar, Badge } from "antd";
import { CommentOutlined } from "@ant-design/icons";
import AwsServerService from "../common/util/AwsServerService";
import { modifyTimezoneString } from "../components/HR/TimeClock/Util";
import dayjs from "dayjs";
import { AppDataRequired } from '../App';
import TaskService from "../../src/common/util/TaskService";
import { getSocket } from "../../src/Socket";

const { TextArea } = Input;

export default function ReportBugComments({ bug }) {
  const currentUser = JSON.parse(localStorage.getItem("userinfo"));
  const { AllUsers } = useContext(AppDataRequired);
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);
  const listRef = useRef(null);
  const socket = getSocket();
  const sendMentionNotification = async (bugId, message) => {debugger
      if (!bugId) return;
      const bugCreatorEmail = bug.CREATEDBY;
      if (bugCreatorEmail === currentUser?.email_id) return;
      const creatorUser = AllUsers.find(u => u.email === bugCreatorEmail);
      if (!creatorUser) return;

      const notifyArray = [creatorUser.zuid];
      
      const commentAuthor = `${currentUser?.first_name} ${currentUser?.last_name}`;
      const displayMessage =
        message?.length > 10
          ? message.slice(0, 10) + "..."
          : message;
      const mentionText = `
        <a style="color:#40a9ff" id="User-${currentUser?.email_id}">
          ${commentAuthor}
        </a>
        <span> commented </span>
        <span><b>'${displayMessage}'</b></span>
        <span> on bug </span>
        <span><b>'${bug.Title || "Bug"}'</b></span>
        `;
        // <a style="color:#40a9ff" id="Bug-${bugId}">
        //   ${bug.Title || "Bug"}
        // </a>
      try {
        await TaskService.SendBugNotificationToMultipleUsers(notifyArray, AllUsers, "Bug", mentionText);
        socket.emit("Refresh_Reminder_List","");
      } catch (error) {
        console.error("Error sending mention notifications:", error);
      }
    };
  useEffect(() => {
    if (listRef.current) {
        setTimeout(() => {
        listRef.current.scrollTo({
        top: listRef.current.scrollHeight,
        behavior: "smooth",
      });
      }, 100);
      }
  }, [comments]);

  const loadComments = async (sent) => {
    setLoading(true);
    try {
      const res = await AwsServerService.getBugComments(bug.ROWID);
     if(!res?.data[0] || res.data[0]?.length === 0) {
        setComments([]);
        setLoading(false);
        return;
      }
      setComments(res.data[0]);
      if(sent){
        setLoading(false);
        return;
      };
      AwsServerService.markCommentsRead(bug.ROWID, currentUser.email_id).then(()=>{
        bug.UnReadCount = 0;
      }); 
    } catch (e) {
      setComments([]);
      message.error("Failed to load comments");
    }
    setLoading(false);
  }; 
 
  const handleSend = async () => {
    if (!text.trim()) return message.warning("Write something before hitting send!");

    const newComment = {
      Comment: text.trim(),
      BugRowId: bug.ROWID,
      Owner: localStorage.getItem("ZUID"),
      OwnerName: currentUser.email_id,
    };
    await AwsServerService.createBugComment(newComment).then(res =>{
      sendMentionNotification(res.data[0]?.insertId, text.trim());
    });
    setText("");
    loadComments(true);
  };
  const getDateLabel = (dateStr) => {
    const d = dayjs(dateStr);
    const now = dayjs(); 
    if (d.isSame(now, "day")) return "Today";
    if (d.isSame(now.subtract(1, "day"), "day")) return "Yesterday"; 
    if (d.isSame(now, "year")) return d.format("MMM D"); 
    return d.format("MMM D YYYY");
  };

 const renderDateDivider = (label) => (
    <div style={{ textAlign: "center", margin: "12px 0" }}>
      <span
        style={{
          background: "#f0f0f0",
          padding: "4px 10px",
          borderRadius: 12,
          fontSize: 12,
          color: "#555",
        }}
      >
        {label}
      </span>
    </div>
  );
  const renderBubble = (c) => {
    const mine = c.OwnerName === currentUser?.email_id;
    return (
      <div
        style={{
            display: "flex",
            justifyContent: mine ? "flex-end" : "flex-start",
            alignItems:"center",
            marginBottom: 8,
        }}
      >
        <Avatar style={{marginRight: "4px"}} src={`https://contacts.zoho.com/file?ID=${c.Owner}&fs=thumb`}/>
        <div
          style={{
            maxWidth: "75%",
            padding: "8px 10px",
            borderRadius: 10,
            background: mine ? "rgb(67 94 133)" : "#eeeeee",
            color: mine ? "#f4f4f4" : "#000",
            wordBreak: "break-word",
          }}
        >
          <div style={{ fontSize: 11, opacity: 0.7 }}>
            {mine ? "• You" : "• " + c.OwnerName}
          </div>

          <div style={{ fontSize: 13 }}>{c.Comment}</div>
          <div style={{ fontSize: 10, opacity: 0.7, marginTop: 4 }}>
                {modifyTimezoneString(c.CREATEDDATE, "MMM DD YYYY hh:mm A")}
            </div>
        </div>
      </div>
    );
  };

  const popoverContent = (
    <div style={{ width: 480 }}>
      <div ref={listRef} style={{ height: 300, overflowY: "auto", paddingRight: 5 }}>
        {loading ? (
          <Spin />
        ) : comments.length === 0 ? (
          <div style={{ textAlign: "center", color: "#999" }}>
            No comments yet
          </div>
        ) : (
          comments.map((c, i) => {
          const current = dayjs(c.CREATEDDATE);
          const prev = i > 0 ? dayjs(comments[i - 1].CREATEDDATE) : null; 
          const showDivider = i === 0 || !current.isSame(prev, "day"); 
          return (
            <React.Fragment key={i}>
              {showDivider && renderDateDivider(getDateLabel(c.CREATEDDATE))}
              {renderBubble(c)}
            </React.Fragment>
          );
        })
        )}
      </div>

      {/* input */}
      <div style={{ display: "flex", gap: 6, marginTop: 10 }}>
        <TextArea
          value={text}
          onChange={(e) => setText(e.target.value)}
          autoSize={{ minRows: 1, maxRows: 5 }}
          placeholder="Type comment..."
        />
        <Button type="primary" onClick={handleSend}>
          Send
        </Button>
      </div>
    </div>
  );

  return (
    <Popover
      content={popoverContent}
      rootClassName="comments-popover-bugreport"
      title="Bug Comments"
      trigger="click"
      open={open}
      onOpenChange={(v) =>{
         if (v) {
            loadComments();
            setOpen(bug.ROWID);
          } else {
            setOpen(false);
          }
      }}
    >
      <Badge count={bug.UnReadCount} showZero={false}>
      <Button color="blue" variant="outlined" icon={<CommentOutlined />} size="small">
        Comments
      </Button>
      </Badge>
    </Popover>
  );
}